import { baseWrapper } from '../xes-common/format';

import { debugLog } from './debug';

import { isRepeat } from './filter';

import { getCookieValue } from '../util/cookie';

import { send } from '../util/send';

/**
 * Instant uploader function
 * Example: `this.instantUploader = instantUploader(this._state, opts)`
 * Instant uploader send log immediately
 * @param {Object} object to logger state
 * @param {Object} object to logger opts
 * @return {Function} send log function
 */
export function instantUploader (state, opts) {
  return function (data, type, panel) {
    var logid = getCookieValue('prelogid') || '';
    var msg = baseWrapper(type, data, logid, state, opts);
    debugLog(panel, msg);

    if (!isRepeat(panel, data)) {
      var url = msg2Url(msg, type);
      send.method.getImage({ url: url });
    }
  };
}

/**
 * Convert log msg object to endpoint url
 * Example: `var url = msg2Url(msg, type)`
 * @param {Object} object to logger state
 * @param {Object} object to logger opts
 */
function msg2Url (msg, type) {
  if (msg) {
    var content = encodeURIComponent(JSON.stringify(msg.content || {}));

    var appid = msg.appid || '';

    var sign = msg.sign || '';

    var clits = msg.clits || '';

    var url;

    url = `https://dj.xesimg.com/appid/${type}.gif?content=${content}&appid=${appid}&sign=${sign}&clits=${clits}`;

    return url;
  } else {
    return '';
  }
}
